import RegistroFB from './RegistroFB';
export default RegistroFB;
